export const ROUTES = {
  dashboard: "yhistu/:id?/toolaud",
  myApartment: "yhistu/:id/korter",
  contacts: "yhistu/:id/kontaktid",
  readings: "yhistu/:id/korterinaidud",
  notifications: "yhistu/:id/teavitused",
  oneNotification: "yhistu/:id/teavitus/:notificationId",
  forum: "yhistu/:id/foorum",
  forumPost: "yhistu/:id/foorumipostitus/:topicId",
  onBoarding: "tingimused",
  rejected: "selgitus",
  bills: "yhistu/:id/arved",
  profile: "profiil",
  boardBills: "majaarved",
  readingsImport: "korterite_naidud/import",
  terms: "kasutustingimused",
  privacy: "privaatsustingimused",
  maintenance: "yhistu/:id/hooldusgraafik",
  maintenanceTask: "yhistu/:id/hooldusgraafik/:maintenanceId",
  documents: "yhistu/:id/dokumendid",
  document: "yhistu/:id/dokument/:documentId",
  statistics: "yhistu/:id/statistika",
  task: "yhistu/:id/tellimustood",
  task_order: "yhistu/:id/tood",
  taskDetail: "yhistu/:id/tellimustood/:taskId",
  meetings: "yhistu/:id/e-koosolekud",
  new_meeting: "yhistu/:id/e-koosolek",
  meeting: "yhistu/:id/e-koosolek/:meetingId",
  paper_voting:
    "yhistu/:id/e-koosolek/:meetingId/paberhaaled/:apartment?/:user?",
  voting: "yhistu/:id/e-koosolek/:meetingId/haaletus/:group?",
  results: "yhistu/:id/e-koosolek/:meetingId/tulemused",
  participation_list: "yhistu/:id/e-koosolek/:meetingId/osalejad",
  county: "piirkonnad",
  labels: "sildid",
  login: "login",
  activate: "activate",
  resetPassword: "reset-password",
  forbidden: "/viga",
  page_not_found: "/*",
  landing: "landing",
  ///
  gauge: "yhistu/:id/mooturid",
  gaugeEdit: "yhistu/:id/mooturid/muuda",
  measureAddApartment: "yhistu/:id/mooturid_korterile",
  measureAddCoop: "yhistu/:id/mooturid_majale",
  periods: "yhistu/:id/perioodid",
  entries: "yhistu/:id/naidud",
  entries_history: "yhistu/:id/naidud/ajalugu",
  cooperative: "yhistu/:id/majad_korterid",
  apartment: "yhistu/:id/korter/:apartmentId",
  cooperativeUser: "yhistu/:id/kasutaja/:userId",
  apartmentUser: "yhistu/:id/korter/:apartmentId/kasutaja/:userId",
  invoices: "yhistu/:id/yhistu-arved",
  //admin Module
  roles: "rollid",
  cooperatives: "yhistud",
  cooperativeDetail: "yhistud/:id/majad_korterid",
  apartmentDetail: "yhistud/:id/korter/:apartmentId",
  cooperativeApartmentAll: "yhistud/:id/lisa_korterid",
  cooperativeUserDetail: "yhistud/:id/kasutaja/:userId",
  apartmentUserDetail: "yhistud/:id/korter/:apartmentId/kasutaja/:userId",
  cooperativePersonsAll: "yhistud/:id/seotud_isikud",
  emailNotification: "teavitused",
  emailNotificationDetail: "teavitused/:id",
  documentCatalogues: "dokumendi_tyybid",
  users: "kasutajad",
  userDetail: "kasutajad/:userId",
  taskAcceptance: "tellimustood/kinnitamine",
  workTypes: "tootuubid",
  taskAcceptanceDetail: "tellimustood/kinnitamine/:taskId",
  search: "otsing",
  alldeviceOjects: "alldevice/objektid"
};

export const ROUTE_NAMES = {
  dashboard: "dashboard",
  myApartment: "my_apartment",
  contacts: "contacts",
  readings: "readings_owner",
  notifications: "Notifications",
  oneNotification: "oneNotification",
  forum: "forum_page",
  forumPost: "Forumpost",
  bills: "bills",
  boardBills: "board_bills",
  profile: "account_settings",
  documents: "Documents",
  document: "Document",
  task: "tasks_2",
  taskOrder: "ordering_tasks_2",
  county: "county",
  taskDetail: "taskdetail",
  terms: "terms",
  terms2: "terms2",
  privacy: "privacy",
  statistics: "statistics",
  maintenance: "maintenance_tasks",
  maintenanceTask: "Maintenance_Task",
  meetings: "meetingDashboard",
  new_meeting: "Meetings",
  meeting: "Meeting",
  voting: "Voting",
  paper_voting: "Paper_voting",
  results: "Results",
  participation_list: "ParticipationList",
  login: "Login",
  readingsImport: "measurer_import",
  activate: "Activate",
  resetPassword: "resetPassword",
  page_not_found: "Page_not_found",
  forbidden: "Forbidden",
  onBoarding: "onBoarding",
  rejected: "rejected",
  landing: "landing",
  ///
  gauge: "measurersList",
  gaugeEdit: "measurerEditAll",
  measureAddApartment: "measureAddApartment",
  measureAddCoop: "measureAddCoop",
  periods: "invoice_periods",
  entries: "entries",
  entries_history: "entries_history",
  cooperative: "cooperative",
  apartment: "apartment",
  cooperativeUser: "cooperativeUser",
  apartmentUser: "apartmentUser",
  invoices: "invoices",
  //admin
  roles: "roles_and_privileges",
  cooperatives: "cooperatives",
  cooperativeDetail: "cooperativeDetail",
  apartmentDetail: "apartmentDetail",
  cooperativeApartmentAll: "cooperativeApartmentAll",
  cooperativePersonsAll: "cooperativePersonsAll",
  emailNotification: "reminder_2",
  taskAcceptance: "taskAcceptance",
  workTypes: "workTypes",
  emailNotificationDetail: "emailNotificationDetail",
  documentCatalogues: "catalogues",
  users: "users",
  userDetail: "userDetail",
  cooperativeUserDetail: "cooperativeUserDetail",
  apartmentUserDetail: "apartmentUserDetail",
  taskAcceptanceDetail: "taskAcceptanceDetail",
  search: "search",
  labels: "translations",
  alldeviceOjects: "alldeviceObjects"
};
